import Button from '@components/std-components/Button'
import PopupComponent from '@components/std-components/Popup'
import { useObserver } from 'mobx-react-lite'
import React, { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import GradingPopupContent from '../../../../../../order/components/CellTemplates/Quantities/DraftUnSizedQuantity/GradingSelectionPopup'
import Icon from '@components/std-components/Icons'
import { Tooltip, makeStyles } from '@material-ui/core'
import { NewEditIcon } from '@components/UI-Components/svg'
import classNames from 'classnames'

interface IEnhancedQuantityGradingPopup {
  isGradingEnabledForProduct: boolean
  isGradingPopupOpen: boolean
  setIsGradingPopupOpen: (value: boolean) => void
  handleGradingCancel: () => void
  handleGradingApply: (productQty: number, selectedGrading: any) => void
  cmRating: any
  gradeCurves: any
  gradingAttributes: any
  popupPosition?: any
  customButtonPositionStyle?: any
}
const useStyles = makeStyles(() => ({
  gradingRoot: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    height: 24,
    right: 0
  },
  gradingIconHolder: {
    display: 'flex',
    alignItems: 'center'
  },
  btn: {
    padding: '0 2px 0',
    '& .icon': {
      cursor: 'inherit'
    }
  }
}))

const EnhancedQuantityGradingPopup: FC<IEnhancedQuantityGradingPopup> = ({
  isGradingEnabledForProduct,
  isGradingPopupOpen,
  setIsGradingPopupOpen,
  handleGradingCancel,
  handleGradingApply,
  cmRating,
  gradeCurves,
  gradingAttributes,
  popupPosition,
  customButtonPositionStyle
}) =>
  useObserver(function useHook() {
    const classes = useStyles()
    const { t } = useTranslation()

    return (
      <>
        {isGradingEnabledForProduct ? (
          <div className={classes.gradingRoot}>
            <PopupComponent
              trigger={
                <Tooltip
                  title={t('order.quantitiesAndBook.gradingModal.grading', 'Grading')}
                >
                  <div className={classes.gradingIconHolder}>
                    <Button
                      variant='link'
                      size='none'
                      style={customButtonPositionStyle ?? {}}
                      className={classNames(classes.btn)}
                    >
                      <div>
                        <Icon imageSrc={NewEditIcon} alt={'edit'} />
                      </div>
                    </Button>
                  </div>
                </Tooltip>
              }
              contentStyle={{
                width: '360px',
                height: '300px',
                padding: 0
              }}
              open={isGradingPopupOpen}
              onOpen={() => setIsGradingPopupOpen(true)}
              onClose={handleGradingCancel}
              position={popupPosition ?? 'right center'}
              lockScroll
              nested={true}
            >
              <GradingPopupContent
                cmRating={cmRating}
                gradeCurves={gradeCurves}
                gradingAttributes={gradingAttributes}
                onApply={handleGradingApply}
                onCancel={handleGradingCancel}
              />
            </PopupComponent>
          </div>
        ) : null}
      </>
    )
  })

export default memo(EnhancedQuantityGradingPopup)
